"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermission = void 0;
var constants_1 = require("../screens/console/pages/users/constants");
var useLoggedInClientUser_1 = require("./useLoggedInClientUser");
// the client user list resolves each record's permissions from its role, which the embedded client.users copy does not
var usePermission = function (permissionKey) {
    var _a, _b, _c, _d;
    var _e = (0, useLoggedInClientUser_1.useLoggedInClientUser)(), loggedInClientUser = _e.loggedInClientUser, isLoading = _e.isLoading;
    var viewPermissions = {};
    var user_permissions = (0, constants_1.resolveEffectivePermissions)((loggedInClientUser === null || loggedInClientUser === void 0 ? void 0 : loggedInClientUser.role) === "ADMIN", undefined, loggedInClientUser === null || loggedInClientUser === void 0 ? void 0 : loggedInClientUser.user_permissions);
    if (!permissionKey)
        Object.keys(constants_1.featurePermissions).forEach(function (key) {
            var _a, _b;
            viewPermissions[key] = (_b = (_a = user_permissions[key]) === null || _a === void 0 ? void 0 : _a.read) !== null && _b !== void 0 ? _b : false;
        });
    var permission = permissionKey ? user_permissions[permissionKey] : null;
    return {
        canViewPermissions: viewPermissions,
        canView: (_a = permission === null || permission === void 0 ? void 0 : permission.read) !== null && _a !== void 0 ? _a : false,
        canUpdate: (_b = permission === null || permission === void 0 ? void 0 : permission.update) !== null && _b !== void 0 ? _b : false,
        canDelete: (_c = permission === null || permission === void 0 ? void 0 : permission.delete) !== null && _c !== void 0 ? _c : false,
        canCreate: (_d = permission === null || permission === void 0 ? void 0 : permission.create) !== null && _d !== void 0 ? _d : false,
        isLoading: isLoading,
    };
};
exports.usePermission = usePermission;
